import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { DabData, ProductKey } from 'graphql-api/gql-api-interfaces';

import * as dabActions from './dab.actions';

/**
 * P-Basket feature key
 */
export const DAB_ITEMS_FEATURE_KEY = 'dabItems';

export type DabItemsState = EntityState<DabData>;

export function selectDabId(data: DabData | ProductKey): string {
  return `${data.brandId}-${data.productId}`;
}

/** State adapter */
export const adapter: EntityAdapter<DabData> = createEntityAdapter<DabData>({
  selectId: selectDabId,
});

/**
 * The initial p-basket state
 */
export const initialState: DabItemsState = adapter.getInitialState();

/**
 * Product basket reducer
 */
const dabReducer = createReducer(
  initialState,
  on(
    dabActions.loadDabSuccess,
    dabActions.updateDab,
    (state, { dabData }): DabItemsState => {
      return adapter.upsertMany(dabData, state);
    },
  ),
  on(dabActions.clearDab, (state) => adapter.removeAll(state)),
);

/**
 * Reducer export
 * @param state The current state
 * @param action The action dispatched
 */
export function reducer(state: DabItemsState | undefined, action: Action) {
  return dabReducer(state, action);
}
